var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.833 38.123h-8.066v7.71m-23.6-7.71h8.066v7.71m23.6-23.956h-8.066v-7.71m-23.6 7.71h8.066v-7.71M26.25 34.75h7.5a1 1 0 0 0 1-1v-7.5a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.49e5a8dec664dd5b8ff34f65d5c819a6.svg";
export { ForwardRef as ReactComponent };